import mergeConfig from 'coact/config/mergeConfig'
import productsSchema from './products/schema.js'
import skusSchema from './skus/schema.js'

const config = {
  models: {
    products: {
      schema: productsSchema,
    },
    skus: {
      schema: skusSchema,
    },
  },
}

export default fullConfig => mergeConfig(fullConfig, config)
